import React, { useState } from "react";
import { APP_SERVICES_URL } from "../../Constant/constant";
import axios from "axios";
import userSession from "../../Constant/auth";
import "react-notifications/lib/notifications.css";
import "../../CSS/ManualInput.css";
import { Modal } from "react-bootstrap";
import "../../Pages/HomePage.css";
import "../../CSS/fonts.css"
import { NotificationContainer, NotificationManager } from "react-notifications";

const ReportStolenPlateModal = ({ show, onHide }) => {
  const { CustID, site, authHeader } = userSession;
  const [stolenPlaceOcr, setUpdatestolenPlaceOcr] = useState("");
  // eslint-disable-next-line
  const [response, setResponse] = useState(false);


  const handleCallToastifyContainer = (Msgtype = null, message = "") => {
    const notificationType = Msgtype ? 'success' : 'error';

    return NotificationManager[notificationType](
      <div className="showNormalFont">{message}</div>,
      <div className="showNormalFont">
        {notificationType === 'success' ? 'Success' : 'Error'}
      </div>,
      3000
    );
  };


  const handleStolenPlate = async (method = 'POST', API_URL = "", body = null) => {
    try {
      const config = {
        headers: {
          Authorization: authHeader,
          'Content-Type': 'application/json',
        }
      };

      let response;

      if (method.toLowerCase() === "post") {
        const postBody = body || {
          licenseNumber: stolenPlaceOcr,
          siteName: site?.name || '',
        };

        response = await axios.post(API_URL, postBody, config);
      } else if (method.toLowerCase() === "delete") {
        response = await axios.delete(API_URL, config); // No body
      } else {
        throw new Error(`Unsupported method: ${method}`);
      }

      onHide();
      setResponse(true);
      setUpdatestolenPlaceOcr("");
      return response?.status && response.status < 400;

    } catch (error) {
      console.error("Error in handleStolenPlate:", error);
      onHide();
      setUpdatestolenPlaceOcr("");
      return false;
    }
  };


  const handleSubmit = async (e) => {
    const action = e.target.dataset.action;
    setResponse(false);

    if (!site || !stolenPlaceOcr || !CustID || !action) {
      return;
    }

    let API_URL;
    let success = false;

    if (action === 'add') {
      // console.log('Adding stolen plate');
      API_URL = `${APP_SERVICES_URL}/senapi/${CustID}/stolenPlate`;
      success = await handleStolenPlate("POST", API_URL);

      if (success) {
        handleCallToastifyContainer(true, "License plate has been successfully marked as stolen.");
      } else {
        handleCallToastifyContainer(false, "Failed to mark the license plate as stolen. Please ensure the number is valid and try again.")

      }

    } else if (action === 'remove') {
      // console.log('Removing stolen plate');
      API_URL = `${APP_SERVICES_URL}/senapi/${CustID}/stolenPlate?ocr=${stolenPlaceOcr}&siteName=${site?.name || ''}`;
      success = await handleStolenPlate("DELETE", API_URL);

      if (success) {
        handleCallToastifyContainer(true, "License plate has been successfully removed from the stolen list.");

      } else {
        handleCallToastifyContainer(false, "Failed to remove the license plate from the stolen list. Please try again later.")
      }
    }

    onHide();
    setUpdatestolenPlaceOcr("");
    setResponse(success);
  };




  const closeModal = () => {
    onHide();
    setUpdatestolenPlaceOcr("");
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <NotificationContainer />
      <div style={{ borderRadius: "10px" }} onClick={handleSubmit}>
        <div className=" manual-input-modal">
          <div className="modal-header">
            <h5
              className="modal-title manual-input-heading"
              id="fullscreenModalLabel"
              style={{ color: "#fff" }}
            >
              Add/Remove Stolen Plate
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={closeModal}
            ></button>
          </div>
          <div className="fluid-container">
            <div className="container">
              <label
                style={{ fontSize: "16px", paddingTop: "10px" }}
                className="showNormalFont"
              >
                Enter registration number to report or remove as stolen.
              </label>
              <input
                type="text"
                autoComplete="off"
                className="form-control mt-2 showNormalFont "
                id="manual-input-box"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-lg"
                value={stolenPlaceOcr}
                onChange={(e) => setUpdatestolenPlaceOcr(e.target.value)} // Update the OCR value in state
                placeholder="Licence Number"
                required
                maxLength={10}
                onInput={(e) => {
                  // Remove non-alphanumeric characters and spaces
                  let sanitizedValue = e.target.value.replace(
                    /[^a-zA-Z0-9]/g,
                    ""
                  );

                  // Update the input value
                  e.target.value = sanitizedValue.toUpperCase();

                  // Update the state with the sanitized value
                  setUpdatestolenPlaceOcr(sanitizedValue);
                }}
              />
            </div>
            <div className="container d-flex justify-content-between manual-input-btns showNormalFont">
              <button
                type="button"
                className="btn btn-modal"
                data-bs-dismiss={response ? "modal" : ""}
                style={{ width: "fit-content" }}
                data-action="add"
              >
                Add
              </button>
              <button
                type="button"
                className="btn btn-modal"
                style={{ width: "fit-content" }}
                data-action="remove"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReportStolenPlateModal;
